// number-anim.js — animates numbers up to their target on scroll-in.
// Trigger element with attribute: mt-el="number-anim"
// Requires: gsap, ScrollTrigger (loaded globally on the Webflow page).

import { scrollTriggerConfig, prefersReducedMotion } from '../motion';

export function initNumberAnim() {
  const els = document.querySelectorAll('[mt-el="number-anim"]');
  if (!els.length) return;

  els.forEach((el) => {
    const raw = el.textContent.trim();
    const target = parseFloat(raw);
    if (isNaN(target)) return;

    const hasDecimal = raw.includes('.');
    const decimalPlaces = hasDecimal ? raw.split('.')[1].length : 0;

    const formatted = (val) =>
      hasDecimal ? val.toFixed(decimalPlaces) : Math.round(val).toLocaleString();

    if (prefersReducedMotion()) {
      el.textContent = formatted(target);
      return;
    }

    el.textContent = '0';
    const obj = { val: 0 };

    gsap.to(obj, {
      val: target,
      duration: 1.6,
      ease: 'power2.out',
      scrollTrigger: {
        ...scrollTriggerConfig({ trigger: el, once: true }),
        invalidateOnRefresh: true,
      },
      onUpdate() {
        el.textContent = formatted(obj.val);
      },
    });
  });
}
